// extracted by mini-css-extract-plugin
module.exports = {"Form":"SubscribeForm_Form__1MChJ","FormHeader":"SubscribeForm_FormHeader__KN_Av","FormControl":"SubscribeForm_FormControl__2AbhN"};